App.CrossLoginRoute = Em.Route.extend
  session: Em.inject.service()

  beforeModel: (transition) ->
    new Em.RSVP.Promise (resolve, reject) =>
      token = transition.params['cross-login'].token

      session = @get('session')

      session.logout()
      session.set('apiKey', token)
      session.loadUser()
      .finally =>
        @transitionTo('index')